import React, { Component } from 'react';
import {withStyles} from '@material-ui/core/styles';
import { CircularProgress, Dialog,DialogContent, Grid } from '@material-ui/core';
const styles = theme => ({
    progress: {
        margin: theme.spacing(4),
    },
    content:{
        backgroundColor:'transparent',
        boxShadow:'unset'
    },
    root: {
        color: theme.palette.background.secondary,
        marginBottom: theme.spacing(2),
    },
});

class Loading extends Component {
    render() {
        const {classes,className,color,showLoading} = this.props;
        return (
            <Dialog open={showLoading} classes={{paper: classes.content}}>
                <DialogContent classes={{root: classes.content}}>
                    <Grid item container justify='center'>
                        <CircularProgress className={classes.root} />
                    </Grid>
                </DialogContent>
            </Dialog>
        );
    }
}
export default withStyles(styles)(Loading);
